<div class="corridor-padding">
  <svg id="otpDtpGraphSvg" width="760" height="300"></svg>
</div>
